// Cross-page row highlight (TASK-52). Reads location.state.highlightId set by
// detail-page back-buttons; clears the state via navigate(replace:true) on
// mount so refresh / re-mount don't re-trigger the pulse.
//
// We latch the consumed id in component state so the row keeps the pulse class
// long enough for the animation (~1.5s) to complete. Clearing only the
// location.state without latching would remove the class on the next render
// and cut the animation short.
//
// Mechanism is intentionally ephemeral — F5 reload clears the highlight,
// which is correct UX for "I just came back from detail; show me where I was".
// See docs/specs/p3-cluster-4-task-51-52.md for the locked decision (Cb).

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export function useHighlightedRow(): { highlightId: string | null } {
  const location = useLocation();
  const navigate = useNavigate();
  const stateHighlightId = (location.state as { highlightId?: string } | null)?.highlightId ?? null;
  const [latched, setLatched] = useState<string | null>(stateHighlightId);

  useEffect(() => {
    if (!stateHighlightId) return;
    setLatched(stateHighlightId);
    navigate(location.pathname, { state: {}, replace: true });
  }, [stateHighlightId, navigate, location.pathname]);

  return { highlightId: latched };
}
